import React,  { useState} from 'react';
import { Plus } from 'lucide-react'
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

const ChatList = () => {
    const [chats, setChats] = useState([
        { id: 1, title: 'Initial Demo Chat to Test Conversation for the Users', dateTime: '2024-09-02T10:30:00' },
        { id: 2, title: 'Chat 2', dateTime: '2024-09-02T14:45:00' },
        { id: 3, title: 'Chat 3', dateTime: '2024-09-02T17:15:00' },
    ]);

    const AddNewThread = () => {
        const newChat = {
            id: uuidv4(),
            title: 'new thread',
            dateTime: new Date().toISOString() // Adds current date and time
        };
    
        setChats([...chats, newChat]);
    };



  return (
    <>
        <div className='flex justify-between items-center mb-2'>
            <h3 className='font-bold text-sm text-gray-600'>All Tasks</h3>
            <button className='p-1 rounded-full hover:bg-gray-200' onClick={AddNewThread}>
                <Plus className="h-4 w-4 text-gray-600" />
            </button>
        </div>
        <ul className='text-xs text-gray-500'>
            {chats.map((chat) => (
                <li key={chat.id} className='mb-1 cursor-pointer hover:bg-gray-200 p-1 rounded flex justify-between items-center whitespace-nowrap overflow-hidden'>
                    <span className='truncate '>{chat.title}</span>
                    <span className='text-gray-400 flex-shrink-0'>{moment(chat.dateTime).fromNow()}</span>
                </li>
            ))}
        </ul>
    </>
  );
};

export default ChatList;
